import { CanGetCertData, IGetCertData } from './types';

enum Action {
  GET_SERT = 'actionGetCert',
  ACTION_TEXT = 'Получить сертификат',
}

const canGetCertData = (data: IGetCertData): CanGetCertData => {
  return {
    id: data!.id || '',
    childName:
      data!.last_name && data!.first_name
        ? `${data.last_name} ${data.first_name}`
        : 'Без имени',
    isNoType: true,
    action: Action.GET_SERT,
    actionText: Action.ACTION_TEXT,
  };
};

export default canGetCertData;



// WEBPACK FOOTER //
// ./src/services/pfdod/utils/canGetCertData.ts